import React from "react";
import logoStatic from "../../assets/imgs/inyc_static.png";
import { useData } from "../../context/DataContext/DataProvider";
import { getCategoryPalette } from "../../util/categoryPalette";

const AppStatusScreen = ({
  title,
  subtitle,
  body,
  children,
  actions,
  centerClassName = "",
  actionsClassName = "",
  contentClassName = "",
  bodyClassName = "",
  subtitleClassName = "",
  subtitleStyle,
  paletteClassName = "",
  paletteStyle,
  actionsStyle,
  logoWrapperStyle,
  hideLogo = false,
  preview = false,
}) => {
  const data = useData();
  const categories = getCategoryPalette(data?.globalConfig?.categories);

  return (
    <div className={`${preview ? "relative h-[44rem] rounded-kit-xl border-[1px] border-divider" : "fixed inset-0 z-[100000] min-h-[100dvh]"} w-full overflow-hidden bg-[var(--inyc-primary)] text-[var(--inyc-primary-text-color)]`}>
      <div className={`mx-auto flex ${preview ? "h-full" : "min-h-[100dvh]"} w-full max-w-[500px] flex-col px-kit-40 pb-[calc(env(safe-area-inset-bottom)+2.35rem)] pt-[calc(env(safe-area-inset-top)+2.2rem)]`}>
        {!hideLogo && (
          <div className="ml-auto w-[6.4rem] shrink-0" style={logoWrapperStyle}>
            <img
              src={logoStatic}
              alt="in-yc"
              className="block w-full object-contain invert-[var(--inyc-invert-black)]"
            />
          </div>
        )}

        <main className="flex min-h-0 flex-1 items-center justify-center">
          <div className={`w-full text-center ${contentClassName}`.trim()}>
            <div className={`mx-auto flex max-w-[27rem] flex-col items-center ${centerClassName}`.trim()}>
              <h1 className="font-['Primary-Bold'] text-kit-xl leading-[1.05] tracking-[-0.04em] !text-[var(--inyc-primary-text-color)]">
                {title}
              </h1>
              {subtitle && (
                <div
                  className={`mt-kit-12 font-['Primary-Bold'] text-kit-base leading-[1.25] tracking-[-0.02em] !text-[var(--inyc-primary-text-color-light)] ${subtitleClassName}`.trim()}
                  style={subtitleStyle}
                >
                  {subtitle}
                </div>
              )}
              {body && (
                <div className={`mt-kit-32 flex flex-col gap-kit-24 font-['Primary-Bold'] text-kit-base leading-[1.45] tracking-[-0.02em] [&_p]:!text-[var(--inyc-primary-text-color-light)] ${bodyClassName}`.trim()}>
                  {body}
                </div>
              )}
              <div
                className={`mt-[calc(0.95rem+15px)] flex items-center justify-center gap-kit-16 ${paletteClassName}`.trim()}
                style={paletteStyle}
              >
                {categories.slice(0, 6).map((category, index) => (
                  <span
                    key={`${category.activeColor}-${index}`}
                    className="h-[1.05rem] w-[1.05rem] rounded-kit-full"
                    style={{ backgroundColor: category.activeColor }}
                  />
                ))}
              </div>
              {children}
              {actions && (
                <div className={`mt-kit-40 flex w-full justify-center ${actionsClassName}`.trim()} style={actionsStyle}>
                  {actions}
                </div>
              )}
            </div>
          </div>
        </main>

      </div>
    </div>
  );
};

export default AppStatusScreen;
